import axios from 'axios';

import { type CirclesGameState, type CirclesGameStateResponse } from './types';

const CIRCLES_BASE_URL = 'https://circles-api.good-games.xyz';

const circlesApi = axios.create({
  baseURL: CIRCLES_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-API-Key': import.meta.env.VITE_CIRCLES_API_KEY,
  },
});

export const getCirclesGameState = async (
  gameKey: string,
  telegramId: number
): Promise<CirclesGameState> => {
  const { data } = await circlesApi.get<CirclesGameStateResponse>(
    `/api/v1/games/${gameKey}/state`,
    { params: { telegramId } }
  );
  return data.response;
};
